'use client'

import { BiLogoInstagram } from 'react-icons/bi'

import { CONTACT, LINKS } from '@/config/constants'

import { ExpandedLogo } from '../ExpandedLogo'
import { Logo } from '../Logo'

import './styles.scss'

export function Footer() {
  const NAVBAR_HEIGHT = 80

  const scrollToSection = (
    e: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string,
  ) => {
    const section = document.querySelector(`section#${sectionId}`)
    if (section) {
      e.preventDefault()
      const rect = section.getBoundingClientRect()
      const offsetTop = rect.top + window.pageYOffset - NAVBAR_HEIGHT
      window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    }
  }

  return (
    <footer className="footer" id="footer" role="contentinfo">
      <div className="container content">
        <div className="logo">
          <Logo color="var(--primary)" size={24} aria-hidden />
          <div style={{ marginTop: -56 }} aria-hidden>
            <ExpandedLogo color="var(--primary)" size={200} />
          </div>
        </div>

        <div className="columns">
          <nav aria-label="Rodapé">
            <h2 className="footer__heading">Mapa do site</h2>
            <ul role="list">
              <li>
                <a
                  href="#hero"
                  onClick={(e) => scrollToSection(e, 'hero')}
                  className="link"
                >
                  Início
                </a>
              </li>
              <li>
                <a
                  href="#cake-maker"
                  onClick={(e) => scrollToSection(e, 'cake-maker')}
                  className="link"
                >
                  Encomende
                </a>
              </li>
              <li>
                <a
                  href="#flavors"
                  onClick={(e) => scrollToSection(e, 'flavors')}
                  className="link"
                >
                  Sabores
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  onClick={(e) => scrollToSection(e, 'about')}
                  className="link"
                >
                  A Sancta Fatia
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  onClick={(e) => scrollToSection(e, 'faq')}
                  className="link"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a href="#footer" className="link">
                  Contato
                </a>
              </li>
            </ul>
          </nav>

          <div className="footer__contact">
            <h2 className="footer__heading">Contato</h2>
            {/* NAP visível: fator direto de SEO local. Deve bater exatamente
                com o Google Business Profile e o Instagram. */}
            <address>
              <a href={LINKS.ORDER_WHATSAPP_URL} className="link">
                WhatsApp {CONTACT.PHONE_DISPLAY}
              </a>
              <p className="footer__region">
                R. João Fernandes, 125
                <br />
                Jardim Nossa Senhora do Carmo
                <br />
                São Paulo &ndash; SP, {CONTACT.POSTAL_CODE}
              </p>
              <p className="footer__region">
                Atendimento e encomendas: todos os dias, das 9h às 21h.
                <br />
                Entrega em toda a Zona Leste.
              </p>
            </address>
          </div>

          <div>
            <h2 className="footer__heading">Redes sociais</h2>
            <a
              href={LINKS.INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="social"
              aria-label="Abrir perfil da Sancta Fatia no Instagram"
            >
              <BiLogoInstagram size={24} aria-hidden />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
